export default __webpack_public_path__ + "static/media/venus.a04d79dc.obj";